import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { ApplicationConstantsEnum } from "../../core/enums/applications-constants.enum";

@Injectable({
  providedIn: "root",
})
export class FileManagerRemoteService {
  constructor(private httpClient: HttpClient) {}

  putFile(fileUrl: string, file: File, fileType: string): Observable<number> {
    const fileBytes = new Blob([file]);
    const contentType = (
      fileType === ApplicationConstantsEnum.PDF
        ? ApplicationConstantsEnum.APPLICATION_PDF
        : ApplicationConstantsEnum.IMAGE_JPEG
    ) as string;

    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", contentType);

    const httpRequest = new HttpRequest("PUT", fileUrl, fileBytes, {
      headers,
      reportProgress: true,
    });

    return this.httpClient.request(httpRequest).pipe(
      map((event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          return Math.round(100 * (event.loaded / event.total));
        } else {
          return 0;
        }
      }),
      catchError((error) => {
        return throwError([]);
      }),
    );
  }
}
